var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full flex align-center justify-center my-custom-spinner"},[_c('div',{staticClass:"w-full h-full position-relative"},[_c('div',{staticClass:"loading"},[_c('div',{staticClass:"effects effect-1"})])])])
}]

export { render, staticRenderFns }